import { atom } from 'recoil';
import { PAGE_NM } from '../../types/types';
import { HOME_TABS } from '../../staticData/home/HOME_TABS';

const homeTab = atom<typeof HOME_TABS[number]['value']>({
  key: 'homeTab',
  default: PAGE_NM.HOME,
});

export { homeTab };
